export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-900 text-foreground-100">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
            <div className="col-span-2 md:col-span-1">
              <div className="flex items-center gap-2 mb-4">
                <div className="w-7 h-7 flex items-center justify-center">
                  <i className="ri-movie-2-line text-xl"></i>
                </div>
                <span className="text-lg font-bold font-heading">极速影视</span>
              </div>
              <p className="text-sm text-foreground-300 leading-relaxed">
                极速影视高清电影大全，汇聚最新院线大片和热门推荐。免费在线观看不缓冲，每日同步更新高清资源，为影迷打造极致观影体验。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold mb-4 text-foreground-50">快速导航</h4>
              <ul className="space-y-2.5">
                <li><a href="#hero" className="text-sm text-foreground-300 hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap">首页</a></li>
                <li><a href="#about" className="text-sm text-foreground-300 hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap">关于我们</a></li>
                <li><a href="#index" className="text-sm text-foreground-300 hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap">专题合集</a></li>
                <li><a href="#ranking" className="text-sm text-foreground-300 hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap">热门榜单</a></li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold mb-4 text-foreground-50">服务支持</h4>
              <ul className="space-y-2.5">
                <li><a href="#faq" className="text-sm text-foreground-300 hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap">常见问题</a></li>
                <li><a href="#contact" className="text-sm text-foreground-300 hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap">投稿合作</a></li>
                <li><a href="#app" className="text-sm text-foreground-300 hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap">移动端观影</a></li>
                <li><a href="#updates" className="text-sm text-foreground-300 hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap">最新动态</a></li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold mb-4 text-foreground-50">合作伙伴</h4>
              <p className="text-sm text-foreground-400 leading-relaxed">
                诚邀各大影视平台、内容创作者及品牌方加入合作，共同为影迷提供更丰富的高清观影资源。
              </p>
            </div>
          </div>

          <div className="border-t border-foreground-800 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-400">
              &copy; 2026 极速影视 版权所有 | 高清电影大全免费在线观看
            </p>
            <div className="flex items-center gap-4">
              <span className="text-xs text-foreground-400">关注我们</span>
              <a href="#hero" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800 text-foreground-300 hover:text-accent-400 transition-colors cursor-pointer">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#hero" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800 text-foreground-300 hover:text-accent-400 transition-colors cursor-pointer">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#hero" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800 text-foreground-300 hover:text-accent-400 transition-colors cursor-pointer">
                <i className="ri-bilibili-line"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}